import { MatchSounds } from 'components/MatchSounds';
import { BrowserNotification } from 'components/BrowserNotification';
import { ChatMessageNotification } from 'models/ChatMessage';

// Announces the opponent's new host code, on whatever page the player is on
// (react/dock/MatchDock watches for it): the host code sound, a browser
// notification that copies the code when clicked, and a notice in the match
// chat. The sound follows the play_notifications setting and the notification
// receive_browser_notifications.
export default function alertHostCode(match, hostCode) {
	const player = hostCode.player || null;
	const playerName = player?.displayedName || player?.username || 'Your opponent';

	const notice = ChatMessageNotification.create();
	notice.type = ChatMessageNotification.types.HOST_CODE;
	notice.player = player;
	notice.match = match;
	notice.hostCode = hostCode;
	notice.myPlayer = match.getMyPlayer?.() || null;
	match.postNotification(notice);

	MatchSounds.hostCode();

	BrowserNotification.showNotification('Host Code Posted!', {
		body: `${playerName} updated the match host code`,
		anyPage: true,
		onClick: () => {
			copyToClipboard(hostCode.code, (text) => {
				BrowserNotification.showNotification('Clipboard Updated!', {
					body: `Copied ${text} to your clipboard`,
					anyPage: true,
				});
			});
		},
	});
}
